(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ff-personalization"] && !Shopify.designMode) return;
  try {
    // Bundled by Shopify into the theme's block scripts (loaded once, deferred, on every page).
  (function () {
    var KEY = 'properties[Personalization]';
    var MAX = 80;
    // Only characters the print font can draw (Latin, Greek, Cyrillic, common punctuation); no emoji.
    var UNPRINTABLE = /[^\u0020-\u007E\u00A0-\u024F\u0370-\u03FF\u0400-\u04FF\u2010-\u2022\u2026\u2032\u2033\u2039\u203A]/g;

    // The one cleaning rule, shared by the cart property and the preview (same as cleanDetail in
    // assets/fairway-frame.js): printable characters only, no < or >, whitespace collapsed, 80 characters.
    function cleanPersonalization(value) {
      return String(value || '')
        .normalize('NFC')
        .replace(/[<>]/g, '')
        .replace(UNPRINTABLE, '')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, MAX)
        .trim();
    }

    // 1. Cart property. Cleans Personalization on every product-form submission, before /cart/add,
    // and drops it when blank. Only the field that belongs to the submitted form AND sits outside
    // the quick-add dialog counts: quick add re-renders a product page inside #quick-add-dialog,
    // where the repeated form id would otherwise tie that copy of the field to the page's own form.
    // Round: 18 scores 1-20 (9 on a nine-hole course), as fairway_frame.render.clean_scores reads them.
    var ROUND_KEY = 'properties[Round]';
    var ROUND_MAX = 20;

    // The .ff-round that belongs to a form (outside the quick-add dialog), or null.
    function roundFor(form) {
      var hidden = document.querySelectorAll('input.ff-round__value');
      for (var i = 0; i < hidden.length; i++) {
        if (hidden[i].form === form && !hidden[i].closest('#quick-add-dialog')) return hidden[i].closest('.ff-round');
      }
      return null;
    }

    // { pars, scores (number or null per hole), filled, complete, bad (holes out of range) } for one .ff-round.
    function readRound(box) {
      var pars = String(box.getAttribute('data-pars') || '').split(',').map(function (v) { return parseInt(v, 10); });
      var inputs = box.querySelectorAll('input.ff-round__score');
      var scores = [];
      var filled = 0;
      var bad = [];
      for (var i = 0; i < inputs.length; i++) {
        var raw = String(inputs[i].value || '').replace(/\D/g, '');
        var n = raw ? parseInt(raw, 10) : null;
        if (n !== null) {
          filled++;
          if (n < 1 || n > ROUND_MAX) bad.push(i + 1);
        }
        scores.push(n);
      }
      return { pars: pars, scores: scores, inputs: inputs, filled: filled, bad: bad,
        row: parseInt(box.getAttribute('data-score-row'), 10) === 3 ? 3 : 4,
        complete: (pars.length === 18 || pars.length === 9) && inputs.length === pars.length && filled === pars.length && !bad.length };
    }

    function sum(list) {
      var t = 0;
      for (var i = 0; i < list.length; i++) t += list[i] || 0;
      return t;
    }

    // The cart property: "5 5 4 3 6 4 4 3 5 | 4 5 3 5 5 5 4 2 4 = 76"; a nine-hole round "5 5 4 3 6 4 4 3 5 = 39".
    function roundText(round) {
      if (round.scores.length === 9) return round.scores.join(' ') + ' = ' + sum(round.scores);
      return round.scores.slice(0, 9).join(' ') + ' | ' + round.scores.slice(9).join(' ') + ' = ' + sum(round.scores);
    }

    // Move focus without scrolling: iPhone Safari otherwise scrolls the page behind the pop-up on every box.
    function focusStill(el) {
      if (!el) return;
      try {
        el.focus({ preventScroll: true });
      } catch (e) {
        el.focus();
      }
    }

    // The page stays exactly where it was while the pop-up is open (iOS scrolls the document behind a modal to
    // reach a focused box, and the shopper lands somewhere else when it closes).
    var lockedY = null;
    function lockPage() {
      if (lockedY !== null) return;
      lockedY = window.scrollY || window.pageYOffset || 0;
      var body = document.body.style;
      body.position = 'fixed';
      body.top = -lockedY + 'px';
      body.left = '0';
      body.right = '0';
      body.width = '100%';
    }
    function unlockPage() {
      if (lockedY === null) return;
      var y = lockedY;
      lockedY = null;
      var body = document.body.style;
      body.position = body.top = body.left = body.right = body.width = '';
      window.scrollTo(0, y);
    }
    function openRound(dialog) {
      if (!dialog || dialog.open || !dialog.showModal) return;
      lockPage();
      dialog.showModal();
      if (!dialog.__ffUnlock) {
        dialog.__ffUnlock = true;
        dialog.addEventListener('close', unlockPage); // Done, backdrop, Escape
      }
    }

    if (!window.__ffRoundSubmitGuard) {
      window.__ffRoundSubmitGuard = true;
      // A partly filled round never reaches the cart silently: Add to cart stops and says why. Capture phase on the
      // document runs before the product form's own submit handler.
      document.addEventListener(
        'submit',
        function (event) {
          var box = roundFor(event.target);
          if (!box) return;
          var round = readRound(box);
          if (!round.filled || round.complete) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          openRound(box.querySelector('dialog.ff-round__dialog'));
          var error = box.querySelector('.ff-round__error');
          if (error) error.hidden = false;
          for (var i = 0; i < round.inputs.length; i++) {
            if (round.scores[i] === null || round.bad.indexOf(i + 1) >= 0) {
              focusStill(round.inputs[i]);
              break;
            }
          }
        },
        true
      );
    }

    if (!window.__ffPersonalizationFormdata) {
      window.__ffPersonalizationFormdata = true;
      document.addEventListener(
        'formdata',
        function (event) {
          var fd = event.formData;
          var form = event.target;
          if (fd && fd.has(ROUND_KEY)) {
            var box = roundFor(form);
            var round = box ? readRound(box) : null;
            fd.delete(ROUND_KEY);
            if (round && round.complete) fd.set(ROUND_KEY, roundText(round));
          }
          if (!fd || !fd.has(KEY)) return;
          var value = '';
          var fields = document.querySelectorAll('input[name="' + KEY + '"]');
          for (var i = 0; i < fields.length; i++) {
            if (fields[i].form === form && !fields[i].closest('#quick-add-dialog')) {
              value = fields[i].value;
              break;
            }
          }
          value = cleanPersonalization(value);
          fd.delete(KEY);
          if (value) fd.set(KEY, value);
        },
        true
      );
    }

    // 2. Live preview on the product gallery. Draws the cleaned, uppercased text over each poster
    // image with the builder's slot: an SVG with viewBox W x 1200 (W = 900 for the 3:4 art,
    // 800 for the 2:3 art), text centred at x = W/2 on baseline y = 165.36, Arial 10.5, tracking 1.35,
    // the style's ink at .78. The SVG takes the image element's own box and mirrors its object-fit /
    // object-position through preserveAspectRatio, so it lands on the drawn picture even when the
    // gallery letterboxes it. pointer-events: none keeps swipes, clicks and zoom working.
    // The gallery is replaced on every variant change (media-gallery.js) and can be morphed, so a
    // MutationObserver re-applies the overlays. Runs only on pages with the field, never for the
    // quick-add dialog's copy of a product page.
    //
    // 3. Frame preview on the same poster images, but only in the slideshow slides: the Frame option
    // chosen in this section's variant picker (matched by name, not position) draws the builder's frame
    // around the picture. The image keeps its box; padding on it makes object-fit: contain draw the
    // picture smaller, and a frame element sits behind the image, around the drawn picture, so the frame
    // never covers the art and the overlay above (which follows the content box) stays aligned.
    //
    // 4. Live size guide on the "sofa" picture (its slideshow slide and the zoom dialog). The static PNG
    // (tools/gallery_extras.py) shows the three print sizes to scale over the builder's 84 in sofa: 1800 x 2400 canvas,
    // 19 px per inch, prints bottom-aligned 10 in above the sofa back, 5 in apart, centred on the sofa, in the
    // Architectural style. An SVG with that canvas as its viewBox is laid exactly over the drawn picture (place(), as
    // the overlay) and repaints the whole scene with the picked Style's art (from the block's JSON island), the picked
    // Frame drawn to scale around each piece and the picked Size marked. The <img> stays underneath (alt text, zoom
    // clicks, thumbnails); the SVG is aria-hidden and takes no pointer events. No island, no art for the style, a
    // picture that failed to load, or another picture ratio: no SVG, the PNG shows as it is. A variant picked while the
    // size guide is showing keeps the re-rendered carousel on it. The other styles' art is preloaded once a size guide
    // is in view.
    if (window.__ffPersonalizationPreview) return;
    window.__ffPersonalizationPreview = true;
    if (typeof MutationObserver !== 'function' || typeof requestAnimationFrame !== 'function') return;

    var SVGNS = 'http://www.w3.org/2000/svg';
    var FIELD = 'input.ff-personalization__input';
    var IMAGES = 'media-gallery .product-media > img.product-media__image';
    var OVERLAY = 'ff-pz-overlay';
    var FRAME = 'ff-pz-frame';
    var FRAME_OPTION = /^frame$/i;
    // Frame value -> data-frame look. Walnut is Espresso's old name and draws the Espresso frame.
    var FRAME_KINDS = { black: 'black', espresso: 'espresso', walnut: 'espresso', natural: 'natural' };
    // Frame width as shoppers see it on the builder's main preview: .ff-gallery-slide--product
    // .ff-gallery-product { padding: 2.5% } (of the framed width; it overrides .ff-builder-art[data-frame]
    // { padding: 6% }) plus the 1px border. Per side: edge = FRAME_PAD * framed width + FRAME_BORDER, so
    // edge = EDGE_A * picture width + EDGE_B.
    var FRAME_PAD = 0.025;
    var FRAME_BORDER = 1;
    var EDGE_A = FRAME_PAD / (1 - 2 * FRAME_PAD);
    var EDGE_B = FRAME_BORDER / (1 - 2 * FRAME_PAD);
    // Room under the frame for its box-shadow (0 12px 24px -4px reaches 32px below), so it fades out on
    // the page before the slide's bottom edge clips it.
    var FRAME_BELOW = 36;
    // Side (and top) margin on the desktop layout: the shadow reaches 20px sideways and fades out inside
    // 24px, so the slide's side edges never cut it off.
    var FRAME_SIDE = 24;
    // Horizon's mobile layout (under 750px): the gallery runs edge to edge and the product title and picker
    // sit on the 16px page margin (base.css --page-margin), so the frame keeps exactly that side margin
    // (the side shadow runs off the screen edge there).
    var PAGE_MARGIN_MOBILE = 16;
    // The frame sits behind the image in an isolated .product-media, which only :has() can target.
    var CAN_FRAME = false;
    var NARROW = null;
    try {
      CAN_FRAME = !!(window.CSS && CSS.supports && CSS.supports('selector(:has(> *))'));
      NARROW = window.matchMedia ? window.matchMedia('screen and (max-width: 749px)') : null;
    } catch (e) {}
    var SLOT = { y: '165.36', font: 'Arial,sans-serif', size: '12', spacing: '1.35', opacity: '.92' };
    var INK = { architectural: '#f2ead8', classic: '#303129', blueprint: '#f2f6f8', vintage: '#33291d' };
    // Round preview: the renderer's chart geometry (render.py) on the W x 1200 canvas and each style's rule colour.
    var LINE = { architectural: '#c7c9b6', classic: '#505349', blueprint: '#d8e4ec', vintage: '#56483a' };
    var GREEN = { architectural: '#b0bd8d', classic: '#72875a', blueprint: '#f6fafc', vintage: '#5f6340' };
    var CHART_TOP = 1200 * 0.829 + 1200 * 0.0586; // rule, then the HOLE row
    var ROW_STEP = 1200 * 0.0125;
    // "<Course> course map poster, <Style> style, 12×16 / 18×24" or "<Course> course map poster, <Style> style, 24×36"
    // No backslash-b or backslash-slash here: an upload that decodes JSON escapes would break them, hence [/].
    var POSTER_ALT = /(?:^|[^A-Za-z])(Architectural|Classic|Blueprint|Vintage) style,\s*(12\s*[x\u00D7]\s*16\s*[/]\s*18\s*[x\u00D7]\s*24|24\s*[x\u00D7]\s*36)\s*$/i;

    // Size guide (4). "<Course> course map poster in the Architectural style at 12\u00D716, 18\u00D724 and 24\u00D736 inches,
    // shown to scale on a wall above an 84-inch sofa"
    var SOFA = 'ff-pz-sofa';
    var SOFA_ALT = /to scale on a wall above an 84[- ]inch sofa\s*$/i;
    var STYLE_OPTION = /^style$/i;
    var SIZE_OPTION = /^size$/i;
    // The PNG's canvas and geometry (layout.json): px per inch, print bottoms, gap between pieces in inches.
    var SCENE_W = 1800;
    var SCENE_H = 2400;
    var PPI = 19;
    var HANG_Y = 1088;
    var GAP_IN = 5;
    var PIECES = [
      { w: 12, h: 16, art: '3:4', size: '12x16', label: '12\u00D716 in' },
      { w: 18, h: 24, art: '3:4', size: '18x24', label: '18\u00D724 in' },
      { w: 24, h: 36, art: '2:3', size: '24x36', label: '24\u00D736 in' }
    ];
    // Lumaprints frames: a 0.875 in face whose lip covers 0.25 in of the print on each side (so 1.25 in larger).
    var FACE_IN = 0.875;
    var LIP_IN = 0.25;
    // Frame look as the frame preview: edge, then the 110deg face gradient.
    // One frame look (2026-10-27): the --ff-frame-* colours of assets/fairway-header.css, solid faces.
    var LOOK = (function () {
      var cs = null;
      try { cs = getComputedStyle(document.documentElement); } catch (e) {}
      function c(name, fallback) { var v = cs ? String(cs.getPropertyValue(name) || '').trim() : ''; return v || fallback; }
      var out = {};
      [['black', '#1c1c1c', '#111'], ['espresso', '#3a2318', '#2a180f'], ['natural', '#c49a6c', '#a37f55']].forEach(function (f) {
        var face = c('--ff-frame-' + f[0], f[1]);
        out[f[0]] = [c('--ff-frame-' + f[0] + '-edge', f[2]), face, face, face];
      });
      return out;
    })();
    var PAPER = { architectural: '#111711', classic: '#efe8d9', blueprint: '#173a5c', vintage: '#d3c199' };
    // Soft shadow of each piece: [offset down, blur, opacity] x 2 (the PNG's; a frame stands further off the wall).
    var SHADOW_PRINT = [[7, 10, '.3'], [1, 1.5, '.22']];
    var SHADOW_FRAMED = [[10, 13, '.34'], [2, 2.5, '.26']];
    var SANS = 'Arial, "Liberation Sans", Helvetica, sans-serif';
    // Labels: the PNG's ink; the picked size bold and darker under a "Selected" pill, the other two in the footnote's
    // ink. Every piece keeps its true colours (no fading), so frames and art always read as the product.
    var INK_LABEL = '#353831';
    var INK_PICKED = '#1b1d18';
    var INK_OTHER = '#5c5f57';
    var INK_FOOT = '#5c5f57';
    var MARKER = 'Selected';
    var FOOT_PRINT = 'Print sizes to scale with an 84 in sofa';
    // "larger", not "add": the piece grows 1.25 in in width and in height (0.625 in per side), not 1.25 in per side.
    var FOOT_FRAMED = 'To scale with an 84 in sofa \u00B7 framed about 1\u00BC in larger';
    // The PNG's wall (radial falloff from #f4f1ea to #e7e3d9, power 1.6), floor and the builder's sofa (inches).
    var WALL_STOPS = [[0, '#f4f1ea'], [0.1, '#f4f1ea'], [0.2, '#f3f0e9'], [0.3, '#f2efe8'], [0.4, '#f1eee6'], [0.5, '#f0ece4'],
      [0.6, '#eeebe2'], [0.7, '#ede9e0'], [0.8, '#ebe7de'], [0.9, '#e9e5dc'], [1, '#e7e3d9']];
    var SOFA_PARTS = [
      ['ellipse', { cx: 48, cy: 83.7, rx: 43, ry: 1.1, fill: '#000', opacity: '.16' }],
      ['rect', { x: 10.5, y: 80, width: 1.6, height: 4, fill: '#3a3934' }],
      ['rect', { x: 83.9, y: 80, width: 1.6, height: 4, fill: '#3a3934' }],
      ['rect', { x: 9, y: 52, width: 78, height: 17, rx: 3, fill: '#5c6254' }],
      ['rect', { x: 14, y: 54, width: 33.6, height: 13, rx: 3, fill: '#6d7364' }],
      ['rect', { x: 48.4, y: 54, width: 33.6, height: 13, rx: 3, fill: '#6d7364' }],
      ['rect', { x: 12, y: 69, width: 72, height: 11.5, rx: 1.5, fill: '#5c6254' }],
      ['rect', { x: 13.5, y: 64.5, width: 34.3, height: 6.5, rx: 2, fill: '#777d6d' }],
      ['rect', { x: 48.2, y: 64.5, width: 34.3, height: 6.5, rx: 2, fill: '#777d6d' }],
      ['rect', { x: 6, y: 58, width: 8.5, height: 22.5, rx: 2.6, fill: '#666c5e' }],
      ['rect', { x: 81.5, y: 58, width: 8.5, height: 22.5, rx: 2.6, fill: '#666c5e' }]
    ];

    var started = false;
    var pending = 0; // requestAnimationFrame id of the next paint
    var scope = null; // the .shopify-section holding the page's field, from the last paint
    var watched = [];
    var padded = []; // slide images whose padding this script set (to make room for a frame)
    var resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    var sofaCount = 0; // gives each size guide SVG its own gradient / filter ids
    var sofaSpares = []; // the size guides painted last: reused when a gallery re-render replaced their pictures
    var keepSofa = null; // the gallery slideshow that showed the size guide when a variant was picked
    var sofaGuard = null; // { show, until }: a new slideshow just put back on the size guide (see guardSofaSlide)
    var sofaSeen = null; // IntersectionObserver that preloads every style's art once a size guide is in view; false after
    var arts = {}; // art URL -> 0 loading, 1 loaded and decoded, -1 failed
    var artImgs = {}; // art URL -> the Image that loaded it, kept so the browser keeps the picture for the scene
    var artWanted = []; // the two pictures the size guide shows or waits for: only their loads repaint
    var islandText = null; // the JSON island's text and data, parsed once per change
    var islandData = null;

    function pageField() {
      var list = document.querySelectorAll(FIELD);
      for (var i = 0; i < list.length; i++) {
        if (!list[i].closest('#quick-add-dialog')) return list[i];
      }
      return null;
    }

    function schedule() {
      if (!pending) pending = requestAnimationFrame(paint);
    }

    // DOM changes elsewhere on the page (header, cart drawer, other sections) cannot affect the overlays.
    // Inline style changes only matter on a gallery image (a re-render can drop the frame padding); the
    // overlay and frame elements' own styles are written by paint, so they never trigger it again.
    function onMutations(records) {
      keepSofaSlide(); // first: this runs right after a gallery re-render, before the new gallery is drawn
      if (pending) return;
      for (var i = 0; i < records.length; i++) {
        var record = records[i];
        var target = record.target;
        if (record.attributeName === 'style' && !(target.matches && target.matches(IMAGES))) continue;
        if (!scope || !scope.isConnected || scope.contains(target) || target.contains(scope)) return schedule();
      }
    }

    function setAttr(el, name, value) {
      if (el.getAttribute(name) !== value) el.setAttribute(name, value);
    }

    function setStyle(el, name, value) {
      if (el.style[name] !== value) el.style[name] = value;
    }

    // object-position axis -> SVG align keyword (the gallery uses centre).
    function align(value, fallback) {
      var v = String(value || fallback);
      var n = parseFloat(v);
      if (isNaN(n)) return 'Mid';
      if (/%$/.test(v)) return n <= 25 ? 'Min' : n >= 75 ? 'Max' : 'Mid';
      return n === 0 ? 'Min' : 'Mid';
    }

    function aspectFor(cs) {
      if (cs.objectFit === 'fill') return 'none';
      var pos = String(cs.objectPosition || '50% 50%').split(/\s+/);
      return (
        'x' + align(pos[0], '50%') + 'Y' + align(pos[1], '50%') + (cs.objectFit === 'cover' ? ' slice' : ' meet')
      );
    }

    function createOverlay() {
      var svg = document.createElementNS(SVGNS, 'svg');
      svg.setAttribute('class', OVERLAY);
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      var text = document.createElementNS(SVGNS, 'text');
      svg.appendChild(document.createElementNS(SVGNS, 'g')).setAttribute('class', 'ff-pz-round');
      text.setAttribute('y', SLOT.y);
      text.setAttribute('text-anchor', 'middle');
      text.setAttribute('font-family', SLOT.font);
      text.setAttribute('font-size', SLOT.size);
      text.setAttribute('letter-spacing', SLOT.spacing);
      text.setAttribute('opacity', SLOT.opacity);
      svg.insertBefore(text, svg.firstChild);
      return svg;
    }

    function svgEl(parent, tag, attrs) {
      var el = document.createElementNS(SVGNS, tag);
      for (var k in attrs) el.setAttribute(k, String(attrs[k]));
      parent.appendChild(el);
      return el;
    }

    // SCORE row under the chart, as render.py score_row: hole scores with 1-3 circles (under par) or squares
    // (over par), the nine's totals once that nine is complete, and for Classic / Blueprint the chart grid grown by
    // one row. Holes left empty stay blank while the shopper types. A nine-hole course's chart is one centred row of
    // nine closed by TOT, which carries the to-par.
    function drawRound(g, round, style, width) {
      var key = round ? style + '|' + width + '|' + round.scores.join(',') + '|' + round.pars.join(',') + '|' + round.row : '';
      if (g.getAttribute('data-key') === key) return;
      g.setAttribute('data-key', key);
      while (g.firstChild) g.removeChild(g.firstChild);
      if (!round || !round.filled) return;
      var ink = INK[style] || INK.architectural;
      var line = LINE[style] || LINE.architectural;
      var x0 = width * 0.105;
      var x1 = width * 0.895;
      var labelW = 36;
      var colW = (x1 - x0 - 2 * labelW - width * 0.03) / (18 + 3 * 1.3);
      var totalW = colW * 1.3;
      var y = CHART_TOP + (round.row || 4) * ROW_STEP;
      var nines = round.pars.length === 9 ? [
        { x: (width - (labelW + 9 * colW + totalW)) / 2, from: 0, totals: 1, whole: true }
      ] : [
        { x: x0, from: 0, totals: 1 },
        { x: x1 - (labelW + 9 * colW + 2 * totalW), from: 9, totals: 2 }
      ];
      for (var b = 0; b < nines.length; b++) {
        var nine = nines[b];
        var x = nine.x;
        var totalsX = x + labelW + colW * 9;
        var right = totalsX + totalW * nine.totals;
        if (style === 'classic' || style === 'blueprint') {
          var op = style === 'classic' ? '.42' : '.62';
          var top = CHART_TOP + ((round.row || 4) - 1) * ROW_STEP + 4;
          svgEl(g, 'rect', { x: x - 7, y: top, width: right - x + 7, height: ROW_STEP, fill: 'none', stroke: line, 'stroke-width': '.7', opacity: op });
          var xs = style === 'blueprint' ? [] : [x + labelW, totalsX];
          if (style === 'blueprint') {
            for (var c = 0; c < 9; c++) xs.push(x + labelW + colW * c);
            for (var t = 0; t < nine.totals; t++) xs.push(totalsX + totalW * t);
          }
          for (var v = 0; v < xs.length; v++) {
            svgEl(g, 'line', { x1: xs[v], y1: top, x2: xs[v], y2: top + ROW_STEP, stroke: line, 'stroke-width': '.5', opacity: op });
          }
        }
        // The round is the chart's hero row (as the renderer draws it): a tinted band, bold, bigger marks, to par.
        svgEl(g, 'rect', { x: x - 7, y: y - ROW_STEP + 4, width: right - x + 7, height: ROW_STEP, fill: GREEN[style] || GREEN.architectural, opacity: '.22' });
        svgEl(g, 'text', { x: x, y: y, fill: ink, 'font-family': SLOT.font, 'font-size': '7.75', 'letter-spacing': '1.3', opacity: '1', 'font-weight': 'bold' }).textContent = 'SCORE';
        var nineScores = round.scores.slice(nine.from, nine.from + 9);
        for (var i = 0; i < 9; i++) {
          var s = nineScores[i];
          if (s === null || s < 1 || s > ROUND_MAX) continue;
          var cx = x + labelW + colW * (i + 0.5);
          var cy = y - 3.2;
          var diff = s - round.pars[nine.from + i];
          var rings = Math.min(Math.abs(diff), 3);
          for (var r = 0; r < rings; r++) {
            var half = 5.4 + 1.5 * r;
            if (diff < 0) {
              svgEl(g, 'circle', { cx: cx, cy: cy, r: half + 0.3, fill: 'none', stroke: ink, 'stroke-width': '1.1', opacity: '1' });
            } else {
              svgEl(g, 'rect', { x: cx - half, y: cy - half, width: 2 * half, height: 2 * half, fill: 'none', stroke: ink, 'stroke-width': '1.1', opacity: '1' });
            }
          }
          svgEl(g, 'text', { x: cx, y: y, 'text-anchor': 'middle', fill: ink, 'font-family': SLOT.font, 'font-size': '9', opacity: '.95', 'font-weight': 'bold' }).textContent = String(s);
        }
        var complete = function (list) {
          for (var k = 0; k < list.length; k++) if (list[k] === null || list[k] < 1 || list[k] > ROUND_MAX) return false;
          return true;
        };
        var totals = [];
        if (complete(nineScores)) totals.push(sum(nineScores));
        if (nine.totals === 2) {
          if (!complete(nineScores)) totals.push(null);
          totals.push(complete(round.scores) ? sum(round.scores) : null);
        }
        for (var k2 = 0; k2 < totals.length; k2++) {
          if (totals[k2] === null) continue;
          var tEl = svgEl(g, 'text', { x: totalsX + totalW * (k2 + 0.5), y: y, 'text-anchor': 'middle', fill: ink, 'font-family': SLOT.font, 'font-size': '9', opacity: '.95', 'font-weight': 'bold' });
          tEl.textContent = String(totals[k2]);
          if ((nine.totals === 2 && k2 === 1) || nine.whole) {   // the round's total, to par
            var d = totals[k2] - sum(round.pars);
            var sp = document.createElementNS(tEl.namespaceURI, 'tspan');
            sp.setAttribute('font-size', '6.5'); sp.setAttribute('dx', '1.5'); sp.setAttribute('font-weight', 'normal');
            sp.textContent = d === 0 ? 'E' : (d > 0 ? '+' : '') + d;
            tEl.appendChild(sp);
          }
        }
      }
    }

    function overlayFor(img) {
      var next = img.nextElementSibling;
      if (next && next.classList.contains(OVERLAY)) return next;
      var svg = createOverlay();
      img.insertAdjacentElement('afterend', svg);
      return svg;
    }

    function px(value) {
      return parseFloat(value) || 0;
    }

    // Put the overlay on the image's content box, where object-fit draws the picture. They are
    // siblings, so they share a containing block; sizes come from the computed style (sub-pixel,
    // and not affected by the zoom dialog's transform, which the stylesheet copies onto the overlay).
    function place(svg, img) {
      var cs = getComputedStyle(img);
      if (img.offsetWidth && img.offsetHeight) {
        var bl = px(cs.borderLeftWidth) + px(cs.paddingLeft);
        var bt = px(cs.borderTopWidth) + px(cs.paddingTop);
        var w = px(cs.width);
        var h = px(cs.height);
        if (cs.boxSizing === 'border-box') {
          w -= bl + px(cs.borderRightWidth) + px(cs.paddingRight);
          h -= bt + px(cs.borderBottomWidth) + px(cs.paddingBottom);
        }
        if (w > 0 && h > 0) {
          setStyle(svg, 'left', img.offsetLeft + bl + 'px');
          setStyle(svg, 'top', img.offsetTop + bt + 'px');
          setStyle(svg, 'width', w + 'px');
          setStyle(svg, 'height', h + 'px');
        }
      }
      setAttr(svg, 'preserveAspectRatio', aspectFor(cs));
    }

    // Round to 1/100 px, so a length read back from the style attribute compares equal and an
    // unchanged layout never rewrites it.
    function r2(value) {
      return Math.round(value * 100) / 100;
    }

    // Text of an element without the text of its child elements (a legend that also shows the value).
    function ownText(el) {
      var text = '';
      for (var node = el.firstChild; node; node = node.nextSibling) {
        if (node.nodeType === 3) text += node.nodeValue;
      }
      return text.replace(/\s+/g, ' ').trim();
    }

    // The option a picker control belongs to. snippets/variant-main-picker.liquid puts it on every radio
    // and <option> as data-option-name; the legend, the select's name ("options[Frame]") or its label
    // are fallbacks.
    function optionName(control) {
      var name = control.getAttribute('data-option-name');
      if (name) return name.trim();
      var fieldset = control.closest('fieldset');
      var legend = fieldset && fieldset.querySelector('legend');
      if (legend) return ownText(legend);
      var select = control.closest('select');
      if (select) {
        name = select.getAttribute('name') || '';
        if (name.indexOf('options[') === 0 && name.charAt(name.length - 1) === ']') return name.slice(8, -1).trim();
        if (select.labels && select.labels[0]) return ownText(select.labels[0]);
      }
      return '';
    }

    // Black, Espresso (old name Walnut) or Natural (also "Black frame"); Unframed or anything else is no
    // frame. Own keys only: "constructor", "toString" and the like are no frame.
    function frameKind(value) {
      var kind = String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (kind.slice(-6) === ' frame') kind = kind.slice(0, -6);
      return Object.prototype.hasOwnProperty.call(FRAME_KINDS, kind) ? FRAME_KINDS[kind] : '';
    }

    // The product page's own picker in this section (never a quick-add or product-card copy).
    function mainPicker(root) {
      var pickers = root.querySelectorAll('variant-picker');
      var first = null;
      for (var i = 0; i < pickers.length; i++) {
        var picker = pickers[i];
        if (picker.closest('#quick-add-dialog, dialog, product-card, quick-add-component')) continue;
        if (picker.getAttribute('ref') === 'mainVariantPicker') return picker;
        if (!first) first = picker;
      }
      return first;
    }

    // The value the shopper has picked for the option whose name matches the pattern: the checked radio
    // (buttons / swatches) or the selected <option> (dropdowns), or its value when it has only one. '' if none.
    function pickedValue(root, pattern) {
      var picker = mainPicker(root);
      if (!picker) return '';
      var i;
      var controls = picker.querySelectorAll('input[type="radio"], select');
      for (i = 0; i < controls.length; i++) {
        var control = controls[i];
        if (control.tagName === 'SELECT') {
          var option = control.options[control.selectedIndex];
          if (option && pattern.test(optionName(option))) return option.value;
        } else if (control.checked && pattern.test(optionName(control))) {
          return control.value;
        }
      }
      // <div class="variant-option">Frame<span class="variant-option__swatch-value">Espresso</span></div>
      var values = picker.querySelectorAll('.variant-option__swatch-value');
      for (i = 0; i < values.length; i++) {
        var holder = values[i].parentElement;
        if (holder && holder.tagName !== 'LEGEND' && pattern.test(ownText(holder))) {
          return values[i].textContent;
        }
      }
      return '';
    }

    // The frame the shopper has picked (option named Frame): black, espresso, natural or '' (no frame).
    function selectedFrame(root) {
      return frameKind(pickedValue(root, FRAME_OPTION));
    }

    // object-position keyword -> share of the free space left of / above the picture.
    function share(value) {
      var a = align(value, '50%');
      return a === 'Min' ? 0 : a === 'Max' ? 1 : 0.5;
    }

    // Aspect ratio (width / height) object-fit draws with; the alt text's size before the image has loaded.
    function ratioOf(img, fallback) {
      var w = img.naturalWidth;
      var h = img.naturalHeight;
      if (!(w > 0 && h > 0)) {
        w = parseFloat(img.getAttribute('width'));
        h = parseFloat(img.getAttribute('height'));
      }
      return w > 0 && h > 0 ? w / h : fallback;
    }

    function frameFor(img) {
      var children = img.parentElement.children;
      for (var i = 0; i < children.length; i++) {
        if (children[i].classList.contains(FRAME)) return children[i];
      }
      var el = document.createElement('div');
      el.className = FRAME;
      el.setAttribute('aria-hidden', 'true');
      img.parentElement.appendChild(el);
      return el;
    }

    function pad(img, top, right, bottom, left) {
      setStyle(img, 'paddingTop', top);
      setStyle(img, 'paddingRight', right);
      setStyle(img, 'paddingBottom', bottom);
      setStyle(img, 'paddingLeft', left);
    }

    // Frames one slide image. Its box stays as the gallery made it; padding shrinks the content box so
    // the framed picture (plus a margin, and room for the whole shadow below) fits inside it, and
    // object-fit draws the picture there. The frame goes around that drawn picture, with the same contain
    // maths place() hands to the overlay through preserveAspectRatio. Returns null while the image has no
    // layout (its frame and padding are then removed). Everything that can refuse runs before the frame
    // element is created, so a refusal never adds and removes it on every paint.
    function applyFrame(img, kind, fallbackRatio, style, edgeA) {
      // Mock 03 (2026-10-27): the face at true scale, 0.875 in of the picked print's width (7.3% at 12x16, 4.9% at
      // 18x24, 3.6% at 24x36) plus the 1px edge; no mat (the real frames have none).
      var EA = edgeA > 0 ? edgeA : EDGE_A;
      var EB = edgeA > 0 ? FRAME_BORDER : EDGE_B;
      if (!img.offsetWidth || !img.offsetHeight) return null;
      var cs = getComputedStyle(img);
      if (cs.boxSizing !== 'border-box') return null; // padding must not grow the box (base.css: border-box)
      var bl = px(cs.borderLeftWidth);
      var bt = px(cs.borderTopWidth);
      var iw = px(cs.width) - bl - px(cs.borderRightWidth);
      var ih = px(cs.height) - bt - px(cs.borderBottomWidth);
      var ratio = ratioOf(img, fallbackRatio);
      // Side margin: on the mobile layout the page margin, so the frame lines up with the product title and
      // picker below it; on the desktop layout room for the side shadow.
      var gap = NARROW && NARROW.matches ? PAGE_MARGIN_MOBILE : FRAME_SIDE;
      var aw = iw - 2 * gap;
      var ah = ih - gap - FRAME_BELOW;
      var pw = Math.min((aw - 2 * EB) / (1 + 2 * EA), (ah - 2 * EB) / (1 / ratio + 2 * EA));
      if (!(pw > 1)) return null;
      var ph = pw / ratio;
      var left = r2(gap + (aw - pw) / 2);
      var top = r2(gap + (ah - ph) / 2);
      var right = r2(iw - left - pw);
      var bottom = r2(ih - top - ph);
      var frame = frameFor(img); // before reading offsets: it makes .product-media the positioned parent
      pad(img, top + 'px', right + 'px', bottom + 'px', left + 'px');

      // The picture as object-fit draws it in the padded content box.
      var cw = iw - left - right;
      var ch = ih - top - bottom;
      var dw = cw;
      var dh = ch;
      if (cs.objectFit === 'contain' || cs.objectFit === 'scale-down') {
        if (cw / ch > ratio) dw = ch * ratio;
        else dh = cw / ratio;
      }
      var pos = String(cs.objectPosition || '50% 50%').split(/\s+/);
      var x = img.offsetLeft + bl + left + (cw - dw) * share(pos[0]);
      var y = img.offsetTop + bt + top + (ch - dh) * share(pos[1]);
      var edge = dw * EA + EB;
      setAttr(frame, 'data-frame', kind);
      setAttr(frame, 'data-style', style); // the paper colour behind a picture that is still loading (CSS)
      setStyle(frame, 'left', r2(x - edge) + 'px');
      setStyle(frame, 'top', r2(y - edge) + 'px');
      setStyle(frame, 'width', r2(dw + 2 * edge) + 'px');
      setStyle(frame, 'height', r2(dh + 2 * edge) + 'px');
      return frame;
    }

    // ---- 4. Size guide

    // A style's poster art from the block's JSON island ({"classic": {"3:4": url, "2:3": url}, ...}); null when
    // the island, the style or either picture is missing.
    function styleArt(block, style) {
      var island = block && block.querySelector('script.ff-personalization__art');
      var text = island ? island.textContent : '';
      if (text !== islandText) {
        islandText = text;
        islandData = null;
        try {
          islandData = text ? JSON.parse(text) : null;
        } catch (e) {}
      }
      var entry = islandData && style && Object.prototype.hasOwnProperty.call(islandData, style) ? islandData[style] : null;
      if (!entry || typeof entry !== 'object') return null;
      var small = entry['3:4'];
      var large = entry['2:3'];
      return typeof small === 'string' && typeof large === 'string' && small && large ? entry : null;
    }

    // Style option value -> island key; '' for anything but the four styles.
    function styleKey(value) {
      var key = String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
      return Object.prototype.hasOwnProperty.call(PAPER, key) ? key : '';
    }

    // Size option value ("12\u00D716", "12 x 16 in") -> index in PIECES, or -1.
    function sizeIndex(value) {
      var match = /([0-9]+)\s*[x\u00D7]\s*([0-9]+)/i.exec(String(value || ''));
      for (var i = 0; match && i < PIECES.length; i++) {
        if (PIECES[i].size === match[1] + 'x' + match[2]) return i;
      }
      return -1;
    }

    // The slideshow poster's style (for a product without a Style option).
    function posterStyle(images) {
      for (var i = 0; i < images.length; i++) {
        var match = POSTER_ALT.exec(images[i].alt || '');
        if (match && images[i].closest('slideshow-slide') && !images[i].closest('dialog, #quick-add-dialog')) {
          return match[1].toLowerCase();
        }
      }
      return '';
    }

    // Loads and decodes a picture once, off-screen: the SVG only switches to it when it can draw it at once. The Image is
    // kept for the page's life (at most 8), so the picture stays in the browser's memory cache: a style picked again
    // later is drawn by all three pieces in the same frame, never fetched again piece by piece. Only the loads the scene
    // waits for repaint; a preloaded style's picture waits quietly until that style is picked.
    function artState(url) {
      if (!Object.prototype.hasOwnProperty.call(arts, url)) {
        arts[url] = 0;
        var im = new Image();
        artImgs[url] = im;
        var done = function (state) {
          return function () {
            if (arts[url] !== 0 || artImgs[url] !== im) return;
            arts[url] = state || (im.naturalWidth > 0 ? 1 : -1);
            if (artWanted.indexOf(url) >= 0) schedule();
          };
        };
        try {
          im.fetchPriority = 'low';
        } catch (e) {}
        if (typeof im.decode === 'function') {
          im.src = url;
          im.decode().then(done(1), done(0));
        } else {
          im.onload = done(1);
          im.onerror = done(-1);
          im.src = url;
        }
      }
      return arts[url];
    }

    // A picture that failed is tried again after the shopper's next pick (a network blip must not end the size guide
    // for the rest of the visit). Only settled failures are dropped, so no load in flight can report into a new one.
    function forgetFailedArt() {
      for (var url in arts) {
        if (Object.prototype.hasOwnProperty.call(arts, url) && arts[url] < 0) {
          delete arts[url];
          delete artImgs[url];
        }
      }
    }

    // Every style's two pictures (the island's), loaded once at low priority when a size guide is first in view, so a
    // Style picked on the size guide can switch in the next frame instead of waiting for its pictures.
    function preloadArt() {
      var field = pageField();
      var block = field && field.closest('.ff-personalization');
      for (var style in PAPER) {
        if (!Object.prototype.hasOwnProperty.call(PAPER, style)) continue;
        var art = styleArt(block, style);
        if (art) {
          artState(art['3:4']);
          artState(art['2:3']);
        }
      }
    }

    // A size guide counts as seen when half of it is on screen, or it fills half the screen: its slide is the one showing
    // (the carousel clips the others) or the zoom dialog shows it (there it is often taller than the screen, and zoomed
    // on a phone). Once is enough; the observer then goes.
    function onSofaSeen(entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        var box = entry.intersectionRect;
        var root = entry.rootBounds;
        var area = box ? box.width * box.height : 0;
        if (sofaSeen && entry.isIntersecting && (entry.intersectionRatio >= 0.5 || (root && area >= 0.5 * root.width * root.height))) {
          sofaSeen.disconnect();
          sofaSeen = false;
          preloadArt();
          return;
        }
      }
    }

    function watchSofas(list) {
      if (sofaSeen === false || typeof IntersectionObserver !== 'function') return;
      if (!sofaSeen) sofaSeen = new IntersectionObserver(onSofaSeen, { threshold: [0, 0.25, 0.5] });
      for (var i = 0; i < list.length; i++) sofaSeen.observe(list[i]);
    }

    // What the size guides show: the picked Style's art, the picked Frame and Size, and whether both of the style's
    // pictures are decoded (ready). null when the island has no art for the style or one of its pictures failed to load:
    // then there is no size guide and the PNG shows as it is. Loads the style's pictures (once each).
    function sofaScene(block, pictures, frame) {
      var style = styleKey(pickedValue(scope, STYLE_OPTION)) || posterStyle(pictures);
      var art = styleArt(block, style);
      if (!art) return null;
      artWanted = [art['3:4'], art['2:3']];
      var small = artState(art['3:4']);
      var large = artState(art['2:3']);
      if (small < 0 || large < 0) return null;
      return { style: style, art: art, frame: frame, pick: sizeIndex(pickedValue(scope, SIZE_OPTION)), ready: small === 1 && large === 1 };
    }

    function svgNode(parent, tag, attrs) {
      var el = document.createElementNS(SVGNS, tag);
      for (var name in attrs) {
        if (Object.prototype.hasOwnProperty.call(attrs, name)) el.setAttribute(name, String(attrs[name]));
      }
      if (parent) parent.appendChild(el);
      return el;
    }

    function gradientStops(gradient, stops) {
      for (var i = 0; i < stops.length; i++) svgNode(gradient, 'stop', { offset: stops[i][0], 'stop-color': stops[i][1] });
      return gradient;
    }

    // Blurred in sRGB, as the PNG's shadows were (PIL blurs and composites in sRGB).
    function blurFilter(defs, id) {
      var filter = svgNode(defs, 'filter', {
        id: id,
        x: '-50%',
        y: '-50%',
        width: '200%',
        height: '200%',
        'color-interpolation-filters': 'sRGB'
      });
      return svgNode(filter, 'feGaussianBlur', { stdDeviation: 0 });
    }

    // The scene's elements, made once per picture (paintSofa only sets attributes). Wall, floor and sofa as in the
    // PNG; per piece: two shadow layers, the hairline of a bare print, paper, art, frame edge and face; labels, the
    // "Selected" marker (a pill; 58 canvas px bold text: 12.6 px on a 390 px phone, 10.3 px on a 320 px one) and the
    // footnote.
    function createSofa() {
      var id = 'ff-pz-sofa-' + ++sofaCount + '-';
      var svg = svgNode(null, 'svg', {
        'class': SOFA,
        viewBox: '0 0 ' + SCENE_W + ' ' + SCENE_H,
        'aria-hidden': 'true',
        focusable: 'false'
      });
      var defs = svgNode(svg, 'defs', {});
      gradientStops(
        svgNode(defs, 'radialGradient', {
          id: id + 'wall',
          gradientUnits: 'userSpaceOnUse',
          cx: 900,
          cy: 720,
          r: 1710,
          gradientTransform: 'translate(900 720) scale(1 1.122807) translate(-900 -720)'
        }),
        WALL_STOPS
      );
      gradientStops(
        svgNode(defs, 'linearGradient', { id: id + 'floor', gradientUnits: 'userSpaceOnUse', x1: 0, y1: 1810, x2: 0, y2: 2419 }),
        [[0, '#ebe7de'], [1, '#e1dcd1']]
      );
      var parts = { soft: blurFilter(defs, id + 'soft'), tight: blurFilter(defs, id + 'tight'), pieces: [], labels: [] };
      svgNode(svg, 'rect', { width: SCENE_W, height: SCENE_H, fill: 'url(#' + id + 'wall)' });
      svgNode(svg, 'rect', { y: 1810, width: SCENE_W, height: SCENE_H - 1810, fill: 'url(#' + id + 'floor)' });
      svgNode(svg, 'rect', { y: 1804.3, width: SCENE_W, height: 5.7, fill: '#cdc8bd' });
      var sofa = svgNode(svg, 'g', { transform: 'translate(-12 290) scale(' + PPI + ')' });
      var i;
      for (i = 0; i < SOFA_PARTS.length; i++) svgNode(sofa, SOFA_PARTS[i][0], SOFA_PARTS[i][1]);
      for (i = 0; i < PIECES.length; i++) {
        var group = svgNode(svg, 'g', {});
        parts.pieces.push({
          group: group,
          gradient: gradientStops(
            svgNode(defs, 'linearGradient', { id: id + 'frame' + i, gradientUnits: 'userSpaceOnUse' }),
            [[0, '#000'], [0.5, '#000'], [1, '#000']]
          ),
          shadow: svgNode(group, 'rect', { fill: '#1e201c', filter: 'url(#' + id + 'soft)' }),
          contact: svgNode(group, 'rect', { fill: '#1e201c', filter: 'url(#' + id + 'tight)' }),
          hairline: svgNode(group, 'rect', { fill: '#1e201c', 'fill-opacity': '.1' }),
          paper: svgNode(group, 'rect', {}),
          art: svgNode(group, 'image', { preserveAspectRatio: 'none' }),
          edge: svgNode(group, 'path', { 'fill-rule': 'evenodd' }),
          face: svgNode(group, 'path', { 'fill-rule': 'evenodd', fill: 'url(#' + id + 'frame' + i + ')' })
        });
      }
      for (i = 0; i < PIECES.length; i++) {
        var label = svgNode(svg, 'text', { 'text-anchor': 'middle', 'font-family': SANS, 'font-size': 64 });
        label.textContent = PIECES[i].label;
        parts.labels.push(label);
      }
      parts.marker = svgNode(svg, 'g', {});
      svgNode(parts.marker, 'rect', { x: -150, y: -43, width: 300, height: 86, rx: 43, fill: INK_LABEL });
      svgNode(parts.marker, 'text', {
        y: 21,
        'text-anchor': 'middle',
        'font-family': SANS,
        'font-size': 58,
        'font-weight': 700,
        fill: '#fff'
      }).textContent = MARKER;
      parts.foot = svgNode(svg, 'text', {
        x: SCENE_W / 2,
        y: 2165,
        'text-anchor': 'middle',
        'font-family': SANS,
        'font-size': 62,
        fill: INK_FOOT
      });
      svg.ffSofa = parts;
      return svg;
    }

    // The picture's scene: its own, else one a gallery re-render left behind (in page order: the slide's goes to the
    // new slide, the zoom dialog's to the new dialog), else a new one.
    function sofaFor(img) {
      var children = img.parentElement.children;
      var i;
      for (i = 0; i < children.length; i++) {
        if (children[i].ffSofa && children[i].classList.contains(SOFA)) return children[i];
      }
      var svg = null;
      for (i = 0; i < sofaSpares.length && !svg; i++) {
        if (!sofaSpares[i].isConnected) svg = sofaSpares[i];
      }
      svg = svg || createSofa();
      img.insertAdjacentElement('afterend', svg);
      return svg;
    }

    function num(value) {
      return String(r2(value));
    }

    function setBox(el, x, y, w, h) {
      setAttr(el, 'x', num(x));
      setAttr(el, 'y', num(y));
      setAttr(el, 'width', num(w));
      setAttr(el, 'height', num(h));
    }

    function rectPath(x, y, w, h) {
      return 'M' + num(x) + ' ' + num(y) + 'H' + num(x + w) + 'V' + num(y + h) + 'H' + num(x) + 'Z';
    }

    // Lays the scene over the picture and draws it for scene = { style, art, frame, pick, ready } (sofaScene). The
    // pieces keep the PNG's layout: bottoms on the hanging line, GAP_IN apart, the group centred on the sofa; a framed
    // piece is its print plus (FACE_IN - LIP_IN) on each side, the face covering the print's outer LIP_IN.
    function paintSofa(svg, img, scene) {
      var parts = svg.ffSofa;
      place(svg, img);
      var w = px(svg.style.width);
      var h = px(svg.style.height);
      var fit = svg.getAttribute('preserveAspectRatio') || '';
      var scale = (fit.indexOf('slice') >= 0 ? Math.max : Math.min)(w / SCENE_W, h / SCENE_H);
      var edge = scale > 0 ? r2(1 / scale) : 3; // one CSS pixel in scene units: the frame's edge line
      var look = Object.prototype.hasOwnProperty.call(LOOK, scene.frame) ? LOOK[scene.frame] : null;
      var grow = look ? FACE_IN - LIP_IN : 0;
      var shadow = look ? SHADOW_FRAMED : SHADOW_PRINT;
      setAttr(parts.soft, 'stdDeviation', String(shadow[0][1]));
      setAttr(parts.tight, 'stdDeviation', String(shadow[1][1]));
      var total = GAP_IN * (PIECES.length - 1);
      var i;
      for (i = 0; i < PIECES.length; i++) total += PIECES[i].w + 2 * grow;
      var x = (SCENE_W - total * PPI) / 2;
      var ready = true;
      for (i = 0; i < PIECES.length; i++) {
        var spec = PIECES[i];
        var part = parts.pieces[i];
        var ow = (spec.w + 2 * grow) * PPI;
        var oh = (spec.h + 2 * grow) * PPI;
        var y = HANG_Y - oh;
        var ax = x + grow * PPI;
        var ay = y + grow * PPI;
        var aw = spec.w * PPI;
        var ah = spec.h * PPI;
        setBox(part.shadow, x, y + shadow[0][0], ow, oh);
        setAttr(part.shadow, 'fill-opacity', shadow[0][2]);
        setBox(part.contact, x, y + shadow[1][0], ow, oh);
        setAttr(part.contact, 'fill-opacity', shadow[1][2]);
        setBox(part.hairline, ax - 1, ay - 1, aw + 2, ah + 2);
        setAttr(part.hairline, 'display', look ? 'none' : 'inline');
        setBox(part.paper, ax, ay, aw, ah);
        setAttr(part.paper, 'fill', PAPER[scene.style]);
        setBox(part.art, ax, ay, aw, ah);
        // The three pieces switch art together, once both of the style's pictures are decoded (never two styles side
        // by side, never a blank print); until then each keeps the picture it shows, and a new scene stays hidden.
        if (scene.ready) setAttr(part.art, 'href', scene.art[spec.art]);
        else if (!part.art.hasAttribute('href')) ready = false;
        setAttr(part.edge, 'display', look ? 'inline' : 'none');
        setAttr(part.face, 'display', look ? 'inline' : 'none');
        if (look) {
          var face = FACE_IN * PPI;
          var hole = rectPath(x + face, y + face, ow - 2 * face, oh - 2 * face);
          setAttr(part.edge, 'd', rectPath(x, y, ow, oh) + hole);
          setAttr(part.edge, 'fill', look[0]);
          setAttr(part.face, 'd', rectPath(x + edge, y + edge, ow - 2 * edge, oh - 2 * edge) + hole);
          // linear-gradient(110deg, ...) over the face box: direction (sin 110deg, -cos 110deg), CSS gradient length
          var half = ((ow - 2 * edge) * 0.9397 + (oh - 2 * edge) * 0.342) / 2;
          var cx = x + ow / 2;
          var cy = y + oh / 2;
          setAttr(part.gradient, 'x1', num(cx - 0.9397 * half));
          setAttr(part.gradient, 'y1', num(cy - 0.342 * half));
          setAttr(part.gradient, 'x2', num(cx + 0.9397 * half));
          setAttr(part.gradient, 'y2', num(cy + 0.342 * half));
          var stops = part.gradient.getElementsByTagName('stop');
          for (var k = 0; k < stops.length; k++) setAttr(stops[k], 'stop-color', look[k + 1]);
        }
        // Label 34 px above the piece, as in the PNG; the picked size bold with the "Selected" pill 24 px above it.
        var label = parts.labels[i];
        setAttr(label, 'x', num(x + ow / 2));
        setAttr(label, 'y', num(y - 34));
        setAttr(label, 'fill', scene.pick < 0 ? INK_LABEL : scene.pick === i ? INK_PICKED : INK_OTHER);
        setAttr(label, 'font-weight', scene.pick === i ? '700' : '400');
        if (scene.pick === i) setAttr(parts.marker, 'transform', 'translate(' + num(x + ow / 2) + ' ' + num(y - 34 - 113) + ')');
        x += ow + GAP_IN * PPI;
      }
      setAttr(parts.marker, 'display', scene.pick < 0 ? 'none' : 'inline');
      var foot = look ? FOOT_FRAMED : FOOT_PRINT;
      if (parts.foot.textContent !== foot) parts.foot.textContent = foot;
      // A new scene waits for its first pictures, so it never shows blank prints over the PNG's.
      setAttr(svg, 'visibility', ready ? 'visible' : 'hidden');
    }

    // The product gallery's slideshow in root (not a quick-add, product card or dialog copy), or null.
    function gallerySlideshow(root) {
      var list = root.querySelectorAll('media-gallery slideshow-component');
      for (var i = 0; i < list.length; i++) {
        if (!list[i].closest('dialog, #quick-add-dialog, product-card, quick-add-component')) return list[i];
      }
      return null;
    }

    function isSofaSlide(slide) {
      var picture = slide && slide.querySelector ? slide.querySelector('.product-media > img.product-media__image') : null;
      return !!(picture && SOFA_ALT.test(picture.alt || ''));
    }

    // Index of the size guide among a slideshow's slides (Horizon's slides getter), or -1.
    function sofaIndex(show) {
      var slides = show.slides;
      for (var i = 0; slides && i < slides.length; i++) {
        if (isSofaSlide(slides[i])) return i;
      }
      return -1;
    }

    // Horizon's slideshow:select event names the slide it selected: noted per slideshow with the index it set. During an
    // animated jump to a slide that is not next to the current one (a thumbnail click or a dot tap from slide 1 to 3),
    // Horizon moves that slide beside the current one for about half a second, so its index is briefly not the current one.
    function onSlideSelect(event) {
      var show = event.target;
      var detail = event.detail;
      if (show && detail && detail.slide && detail.slide.nodeType === 1 && typeof show.current === 'number') {
        show.ffSelected = { slide: detail.slide, current: show.current };
      }
    }

    // Whether the shopper is on the size guide: the slide last selected while the index is still the one it set (a
    // later scroll or drag, or a new setup, changes it), else the slide at the current index.
    function onSofaSlide(show) {
      if (!show || typeof show.current !== 'number') return false;
      var noted = show.ffSelected;
      if (noted && noted.current === show.current && show.contains(noted.slide)) return isSofaSlide(noted.slide);
      var slides = show.slides;
      return !!(slides && isSofaSlide(slides[show.current]));
    }

    // A variant pick re-renders the gallery (media-gallery.js replaceWith) and Horizon starts the new one on its first
    // slide, the picked poster. When the shopper was looking at the size guide, the new gallery is put straight back on
    // it: the pick is noted here (capture phase, before variant-picker.js), and keepSofaSlide selects the size guide
    // without animation from the MutationObserver callback that follows the re-render, before the new gallery is drawn.
    function noteSofaSlide(root) {
      var show = gallerySlideshow(root);
      keepSofa = onSofaSlide(show) ? show : null;
    }

    function keepSofaSlide() {
      var old = keepSofa;
      if (!old || old.isConnected) return;
      keepSofa = null;
      if (!onSofaSlide(old)) return; // the shopper had moved to another slide before the re-render
      var show = gallerySlideshow(scope && scope.isConnected ? scope : document);
      var index = show ? sofaIndex(show) : -1;
      if (index >= 0 && show.current !== index && typeof show.select === 'function') {
        show.select(index, undefined, { animate: false });
        guardSofaSlide(show);
      }
    }

    // The new slideshow finishes its own setup a few frames later with "no slide reported visible yet -> select the
    // first slide" whenever its IntersectionObserver has not reported by then (a race Horizon loses on slow frames).
    // For a short while such an automatic select (never one the shopper makes) is turned straight back to the size
    // guide, synchronously from Horizon's own select event, so no frame shows the other slide. Released after one
    // correction, on the shopper's first own move, or after 1.5 s.
    function guardSofaSlide(show) {
      releaseSofaGuard();
      sofaGuard = { show: show, until: Date.now() + 1500 };
      show.addEventListener('slideshow:select', onGuardedSelect);
    }

    function releaseSofaGuard() {
      if (sofaGuard) sofaGuard.show.removeEventListener('slideshow:select', onGuardedSelect);
      sofaGuard = null;
    }

    function onGuardedSelect(event) {
      var guard = sofaGuard;
      var detail = event.detail || {};
      if (!guard || event.target !== guard.show) return;
      var index = sofaIndex(guard.show);
      if (detail.userInitiated || Date.now() > guard.until || index < 0 || !guard.show.isConnected) {
        releaseSofaGuard();
      } else if (detail.index !== index) {
        releaseSofaGuard();
        guard.show.select(index, undefined, { animate: false });
      }
    }

    function watch(list) {
      if (!resizeObserver) return;
      var i;
      for (i = 0; i < watched.length; i++) {
        if (list.indexOf(watched[i]) < 0) resizeObserver.unobserve(watched[i]);
      }
      for (i = 0; i < list.length; i++) {
        if (watched.indexOf(list[i]) < 0) resizeObserver.observe(list[i]);
      }
      watched = list;
    }

    function paint() {
      pending = 0;
      var field = pageField();
      var text = field ? cleanPersonalization(field.value).toUpperCase() : '';
      scope = field ? field.closest('.shopify-section') || document : null;
      var roundBox = field ? field.closest('.ff-personalization').querySelector('.ff-round') : null;
      var round = roundBox ? readRound(roundBox) : null;
      var hasRound = !!(round && round.filled);
      var picked = scope ? selectedFrame(scope) : '';
      var kind = CAN_FRAME ? picked : '';
      var pickedSize = scope ? sizeIndex(pickedValue(scope, SIZE_OPTION)) : -1;
      var edgeA = FACE_IN / (pickedSize >= 0 ? PIECES[pickedSize].w : 18);
      var keep = [];
      var frames = [];
      var framed = [];
      var observe = [];

      if ((text || hasRound || kind) && scope) {
        var images = scope.querySelectorAll(IMAGES);
        for (var i = 0; i < images.length; i++) {
          var img = images[i];
          if (img.closest('#quick-add-dialog')) continue;
          var match = POSTER_ALT.exec(img.alt || '');
          if (!match) continue;
          var width = /^24/.test(match[2]) ? 800 : 900;
          observe.push(img, img.parentElement);

          // Frame first: its padding moves the content box the overlay is placed on. Slideshow slides
          // only; the zoom dialog's images are inside media-gallery too.
          var style = match[1].toLowerCase();
          var frame =
            kind && img.closest('slideshow-slide') && !img.closest('dialog') ? applyFrame(img, kind, width / 1200, style, edgeA) : null;
          if (frame) {
            frames.push(frame);
            framed.push(img);
          } else if (padded.indexOf(img) >= 0) {
            pad(img, '', '', '', '');
          }

          if (!text && !hasRound) continue;
          var svg = overlayFor(img);
          var line = svg.querySelector('text');
          setAttr(svg, 'viewBox', '0 0 ' + width + ' 1200');
          setAttr(line, 'x', String(width / 2));
          setAttr(line, 'fill', INK[style] || INK.architectural);
          if (line.textContent !== text) line.textContent = text;
          var roundG = svg.querySelector('g.ff-pz-round');
          if (!roundG) {
            roundG = svgEl(svg, 'g', { 'class': 'ff-pz-round' });
          }
          drawRound(roundG, hasRound ? round : null, style, width);
          place(svg, img);
          keep.push(svg);
        }
      }

      // Size guide: the scene for the picked Style / Frame / Size on the sofa picture in the slideshow and in the
      // zoom dialog (whose mobile pinch / drag transform the stylesheet copies onto it).
      var sofas = [];
      var scene;
      if (scope) {
        var pictures = scope.querySelectorAll(IMAGES);
        for (var k = 0; k < pictures.length; k++) {
          var picture = pictures[k];
          if (!SOFA_ALT.test(picture.alt || '') || !picture.closest('slideshow-slide, zoom-dialog')) continue;
          if (picture.closest('#quick-add-dialog')) continue;
          if (Math.abs(ratioOf(picture, 0.75) - SCENE_W / SCENE_H) > 0.01) continue; // the scene is drawn for 3:4
          if (scene === undefined) scene = sofaScene(field.closest('.ff-personalization'), pictures, picked);
          if (!scene) break;
          observe.push(picture, picture.parentElement);
          var sofa = sofaFor(picture);
          paintSofa(sofa, picture, scene);
          sofas.push(sofa);
        }
        if (sofas.length) {
          sofaSpares = sofas;
          watchSofas(sofas);
        }
      }

      // Empty field, image gone, or no longer a poster image: remove its overlay.
      var all = document.querySelectorAll('svg.' + OVERLAY);
      var j;
      for (j = 0; j < all.length; j++) {
        if (keep.indexOf(all[j]) < 0) all[j].remove();
      }
      // No island / art for the style, a failed picture, picture gone or no longer a slide / zoom picture: remove its
      // size guide.
      all = document.querySelectorAll('svg.' + SOFA);
      for (j = 0; j < all.length; j++) {
        if (sofas.indexOf(all[j]) < 0) all[j].remove();
      }
      // No frame picked, image gone, or no longer a slide poster: remove its frame and the padding.
      all = document.querySelectorAll('.' + FRAME);
      for (j = 0; j < all.length; j++) {
        if (frames.indexOf(all[j]) < 0) all[j].remove();
      }
      for (j = 0; j < padded.length; j++) {
        if (framed.indexOf(padded[j]) < 0) pad(padded[j], '', '', '', '');
      }
      padded = framed;
      watch(observe);

      // Readable copy under the field (the in-art line is print scale, tiny on phones).
      var block = field && field.closest('.ff-personalization');
      var echo = block && block.querySelector('.ff-personalization__echo');
      var echoText = echo && echo.querySelector('.ff-personalization__echo-text');
      if (echo && echoText) {
        if (echoText.textContent !== text) echoText.textContent = text;
        if (echo.hidden !== !text) echo.hidden = !text;
      }
      if (roundBox) {
        var total = roundBox.querySelector('.ff-round__total');
        var holes = round.pars.length === 9 ? 9 : 18;
        var out = round.scores.slice(0, 9);
        var inn = round.scores.slice(9);
        var msg = '';
        if (round.complete) msg = holes === 9 ? 'Total ' + sum(round.scores) : 'Out ' + sum(out) + ' \u00B7 In ' + sum(inn) + ' \u00B7 Total ' + sum(round.scores);
        else if (round.filled) msg = round.filled + ' of ' + holes + ' holes entered';
        if (total && total.textContent !== msg) total.textContent = msg;
        var open = roundBox.querySelector('.ff-round__open');
        var label = round.complete ? 'Edit your score' : round.filled ? 'Finish your score (' + round.filled + ' of ' + holes + ')' : 'Print my score on the card (free)';
        if (open && open.textContent !== label) open.textContent = label;
        var line = roundBox.querySelector('.ff-round__line');
        var lineText = roundBox.querySelector('.ff-round__line-text');
        var shown = !round.complete ? '' : holes === 9 ? 'On your poster: ' + sum(round.scores)
          : 'On your poster: ' + sum(round.scores) + ' (' + sum(out) + ' out, ' + sum(inn) + ' in)';
        if (lineText && lineText.textContent !== shown) lineText.textContent = shown;
        if (line && line.hidden !== !shown) line.hidden = !shown;
        var error = roundBox.querySelector('.ff-round__error');
        if (error && !error.hidden && (round.complete || !round.filled)) error.hidden = true;
      }
    }

    function start() {
      if (started || !pageField()) return;
      started = true;
      new MutationObserver(onMutations).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        // alt: poster detection; style: a re-render dropping the frame padding; checked / selected: the
        // variant picker re-rendered (morph) with another Frame value.
        attributeFilter: ['alt', 'style', 'checked', 'selected'],
      });
      window.addEventListener('pageshow', schedule);
      // Which slide each slideshow last selected (it bubbles from Horizon's slideshow-component).
      document.addEventListener('slideshow:select', onSlideSelect, true);
      // Crossing the mobile / desktop breakpoint changes the frame's side margin.
      if (NARROW && NARROW.addEventListener) NARROW.addEventListener('change', schedule);
      else if (NARROW && NARROW.addListener) NARROW.addListener(schedule);
      schedule();
    }

    function onRoundInput(target) {
      var clean = String(target.value || '').replace(/\D/g, '').slice(0, 2);
      if (target.value !== clean) target.value = clean;
      // Next box after a score that can't grow (2-9, or two digits); a 1 waits for a possible second digit.
      if (clean.length === 2 || /^[2-9]$/.test(clean)) {
        var box = target.closest('.ff-round');
        var inputs = box ? Array.prototype.slice.call(box.querySelectorAll('input.ff-round__score')) : [];
        var next = inputs[inputs.indexOf(target) + 1];
        if (next) focusStill(next);
      }
    }

    document.addEventListener(
      'click',
      function (event) {
        var el = event.target instanceof Element ? event.target : null;
        var box = el && el.closest('.ff-round');
        if (!box) return;
        var dialog = box.querySelector('dialog.ff-round__dialog');
        if (el.closest('.ff-round__open')) {
          openRound(dialog);
          var first = null;
          var boxes = box.querySelectorAll('input.ff-round__score');
          for (var f = 0; f < boxes.length && !first; f++) if (!boxes[f].value) first = boxes[f];
          focusStill(first || boxes[0]);
          start();
          schedule();
          return;
        }
        if (el.closest('.ff-round__done')) {
          if (dialog && dialog.open) dialog.close();
          schedule();
          return;
        }
        // A click on the backdrop (outside the sheet) closes the pop-up too.
        if (el === dialog) {
          dialog.close();
          schedule();
          return;
        }
        if (!el.closest('.ff-round__clear')) return;
        var inputs = box.querySelectorAll('input.ff-round__score');
        for (var i = 0; i < inputs.length; i++) inputs[i].value = '';
        var error = box.querySelector('.ff-round__error');
        if (error) error.hidden = true;
        start();
        schedule();
      },
      true
    );

    function onFieldEvent(event) {
      var target = event.target;
      if (!(target instanceof Element) || target.closest('#quick-add-dialog')) return;
      if (target.matches('input.ff-round__score')) {
        if (event.type === 'input') onRoundInput(target);
        start();
        schedule();
      } else if (target.matches(FIELD)) {
        start();
        schedule();
      } else if (event.type === 'change' && target.closest('variant-picker')) {
        // A variant pick (Frame, Style, Size): repaint now; the gallery re-render that follows repaints again.
        // It also starts the preview: the frame needs no typing, and in the theme editor the field can
        // arrive with a section re-render after this script ran (start() does nothing without the field).
        // Mock 03: picking a frame shows it on the poster (the gallery's first slide after the re-render), so only
        // the other picks keep the size guide in view
        if (/^frame$/i.test(target.getAttribute('data-option-name') || '') && frameKind(target.value)) keepSofa = null;
        else noteSofaSlide(target.closest('.shopify-section') || document);
        forgetFailedArt();
        start();
        if (started) schedule();
      }
    }

    document.addEventListener('input', onFieldEvent, true);
    document.addEventListener('change', onFieldEvent, true);
    // Theme editor: adding or enabling this block (or tagging the product) re-renders the section, but
    // does not run this script again.
    document.addEventListener('shopify:section:load', start);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  // "Zoom in to check it" (shown once a name or round is on the poster) and an "Added to your cart" note after an
  // add from a page with this block. Kept apart from the preview code above.
  (function () {
    function sync(root) {
      var b = root.querySelector('.ff-pz-zoom-open');
      if (!b) return;
      var echo = root.querySelector('.ff-personalization__echo');
      var line = root.closest('.product-details, product-form-component, form, section') || document;
      var round = line.querySelector('.ff-round__line');
      b.hidden = !((echo && !echo.hidden) || (round && !round.hidden));
    }
    function watch() {
      document.querySelectorAll('.ff-personalization').forEach(function (root) {
        if (root.ffZoomWatch) return;
        root.ffZoomWatch = true;
        var mo = new MutationObserver(function () { sync(root); });
        var scope = root.closest('.product-details, product-form-component, form, section') || document;
        scope.querySelectorAll('.ff-personalization__echo, .ff-round__line').forEach(function (el) {
          mo.observe(el, { attributes: true, attributeFilter: ['hidden'] });
        });
        sync(root);
      });
    }
    function currentImage() {
      var shows = document.querySelectorAll('media-gallery slideshow-component');
      for (var i = 0; i < shows.length; i++) {
        var show = shows[i];
        if (show.closest('dialog, product-card, quick-add-component')) continue;
        var slides = show.slides || show.querySelectorAll('slideshow-slide');
        var slide = slides && typeof show.current === 'number' ? slides[show.current] : null;
        var img = slide && slide.querySelector('.product-media img');
        return img || show.querySelector('.product-media img');
      }
      return document.querySelector('media-gallery .product-media img');
    }
    // Owner fix list 2026-10-17 (2): clicking the poster image opened Horizon's zoom, which lands wherever the gallery
    // happens to be (on a phone a zoomed spot in the middle of the map), not on the line the shopper typed. The button
    // now opens its own close-up: the current poster with the same overlay, zoomed so the personalization line (or the
    // SCORE row when only a round is set) sits in view, with a "Back to product" button; Esc and the backdrop close it
    // too, and focus returns to the button. Line slot: baseline y 165.36 of 1200 (render.py); SCORE row: the chart
    // geometry in drawRound above (CHART_TOP + row * ROW_STEP).
    var LINE_Y = 161 / 1200;
    function overlayOf(img) {
      var n = img && img.nextElementSibling;
      return n && n.classList.contains('ff-pz-overlay') ? n : null;
    }
    function posterWithOverlay() {
      var cur = currentImage();
      if (overlayOf(cur) && !cur.closest('dialog')) return cur;
      var all = document.querySelectorAll('media-gallery .product-media > img.product-media__image');
      for (var i = 0; i < all.length; i++) {
        if (overlayOf(all[i]) && !all[i].closest('dialog, #quick-add-dialog')) return all[i];
      }
      return null;
    }
    function hiRes(url) {
      if (!url) return '';
      return /[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=2400') : url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=2400';
    }
    var check = null;
    var opener = null;
    function buildCheck() {
      var d = document.createElement('dialog');
      d.className = 'ff-pz-check';
      d.setAttribute('aria-labelledby', 'ffPzCheckTitle');
      d.innerHTML =
        '<div class="ff-pz-check__bar">' +
        '<button type="button" class="ff-pz-check__back" data-ff-check-close><span aria-hidden="true">&larr;</span> Back to product</button>' +
        '<p class="ff-pz-check__title" id="ffPzCheckTitle">Check your poster</p>' +
        '<div class="ff-pz-check__jump" role="group" aria-label="Show on the poster">' +
        '<button type="button" data-ff-jump="line">Your line</button><button type="button" data-ff-jump="score">Your score</button>' +
        '</div></div>' +
        '<div class="ff-pz-check__stage" tabindex="0" aria-label="Poster close-up. Scroll or drag to look around.">' +
        '<div class="ff-pz-check__art"><img alt=""></div></div>';
      document.body.appendChild(d);
      var stage = d.querySelector('.ff-pz-check__stage');
      d.addEventListener('click', function (e) {
        if (e.target === d || (e.target.closest && e.target.closest('[data-ff-check-close]'))) { d.close(); return; }
        var j = e.target.closest && e.target.closest('[data-ff-jump]');
        if (j) jump(j.getAttribute('data-ff-jump'), true);
      });
      d.addEventListener('close', function () {
        document.documentElement.classList.remove('ff-pz-check-open');
        if (opener && document.contains(opener)) {
          try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); }
        }
      });
      // mouse drag pans the close-up (touch scrolls natively)
      var drag = null;
      stage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button === 0) drag = { x: e.clientX, y: e.clientY, l: stage.scrollLeft, t: stage.scrollTop };
      });
      stage.addEventListener('pointermove', function (e) {
        if (!drag) return;
        stage.scrollLeft = drag.l - (e.clientX - drag.x);
        stage.scrollTop = drag.t - (e.clientY - drag.y);
      });
      window.addEventListener('pointerup', function () { drag = null; });
      return d;
    }
    function textWidth(svg) {
      var t = svg && svg.querySelector('text');
      if (!t || !t.textContent) return 0;
      try { return t.getComputedTextLength() || 0; } catch (e) { return t.textContent.length * 8.5; }
    }
    function jump(which, smooth) {
      var d = check;
      if (!d) return;
      var stage = d.querySelector('.ff-pz-check__stage');
      var art = d.querySelector('.ff-pz-check__art');
      var W = art.offsetWidth, H = art.offsetHeight;
      var fx = 0.5, fy = LINE_Y;
      if (which === 'score') {
        var row = d.ffScoreRow || 4;
        fy = (1200 * 0.829 + 1200 * 0.0586 + row * 1200 * 0.0125 - 3) / 1200;
        // the row is wider than a phone: start at its left end there
        if (W * 0.79 > stage.clientWidth) fx = (0.105 * W - 12 + stage.clientWidth / 2) / W;
      }
      d.ffAt = which;
      d.querySelectorAll('[data-ff-jump]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-ff-jump') === which ? 'true' : 'false');
      });
      var left = fx * W - stage.clientWidth / 2;
      var top = fy * H - stage.clientHeight * 0.4;
      if (stage.scrollTo) stage.scrollTo({ left: left, top: top, behavior: smooth ? 'smooth' : 'auto' });
      else { stage.scrollLeft = left; stage.scrollTop = top; }
    }
    function openCheck(button) {
      var img = posterWithOverlay();
      var svg = overlayOf(img);
      if (!img || !svg) { if (img) img.click(); return; }
      if (!check) check = buildCheck();
      var d = check;
      opener = button;
      var art = d.querySelector('.ff-pz-check__art');
      var pic = art.querySelector('img');
      var old = art.querySelector('svg');
      if (old) old.remove();
      var copy = svg.cloneNode(true);
      copy.setAttribute('class', 'ff-pz-check__overlay');
      copy.removeAttribute('style');
      copy.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      art.appendChild(copy);
      var vb = String(svg.getAttribute('viewBox') || '0 0 900 1200').split(/\s+/).map(Number);
      d.ffViewBox = [vb[2] || 900, vb[3] || 1200];
      var box = button.closest('.ff-personalization');
      var roundBox = box && box.querySelector('.ff-round');
      d.ffScoreRow = roundBox ? parseInt(roundBox.getAttribute('data-score-row'), 10) || 4 : 4;
      var hasLine = !!(svg.querySelector('text') && svg.querySelector('text').textContent);
      var roundG = svg.querySelector('g.ff-pz-round');
      var hasScore = !!(roundG && roundG.firstChild);
      d.querySelector('[data-ff-jump="line"]').hidden = !hasLine;
      d.querySelector('[data-ff-jump="score"]').hidden = !hasScore;
      d.querySelector('.ff-pz-check__jump').hidden = !(hasLine && hasScore);
      // Low-res picture at once (already loaded), the 2400 px one swapped in when it arrives.
      var src = img.currentSrc || img.src;
      pic.src = src;
      pic.alt = (img.alt || 'Poster') + ', close-up';
      var big = hiRes(src);
      if (big && big !== src) {
        var pre = new Image();
        pre.onload = function () { if (pic.src === src) pic.src = big; };
        pre.src = big;
      }
      document.documentElement.classList.add('ff-pz-check-open');
      d.showModal();
      // Zoom: the line about 18 px tall (font 12 in the 900-wide slot), never wider than the screen; at least the
      // screen's width. The SCORE row alone gets the same zoom and the shopper pans along it.
      var stage = d.querySelector('.ff-pz-check__stage');
      var sw = stage.clientWidth || window.innerWidth;
      var vw = d.ffViewBox[0];
      var W = (18 * vw) / 12;
      var tw = hasLine ? textWidth(svg) : 0;
      if (tw > 0) W = Math.min(W, (0.9 * sw * vw) / tw);
      W = Math.max(W, sw, 320);
      art.style.width = Math.round(W) + 'px';
      art.style.height = Math.round((W * d.ffViewBox[1]) / vw) + 'px';
      jump(hasLine ? 'line' : 'score', false);
      var back = d.querySelector('[data-ff-check-close]');
      try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); }
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.ff-pz-zoom-open');
      if (!b) return;
      e.preventDefault();
      openCheck(b);
    });
    function toast() {
      var t = document.querySelector('.ff-cart-toast');
      if (!t) {
        t = document.createElement('div');
        t.className = 'ff-cart-toast';
        t.setAttribute('role', 'status');
        t.innerHTML = '<span>Added to your cart</span><a href="/cart">View cart</a>';
        document.body.appendChild(t);
      }
      t.classList.add('is-on');
      clearTimeout(t.ffTimer);
      t.ffTimer = setTimeout(function () { t.classList.remove('is-on'); }, 6000);
    }
    var fetch0 = window.fetch;
    if (fetch0 && !window.ffCartToastHook) {
      window.ffCartToastHook = true;
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var res = fetch0.apply(this, arguments);
        if (/\/cart\/add/.test(url) && document.querySelector('.ff-personalization')) {
          res.then(function (r) { if (r && r.ok) toast(); }).catch(function () {});
        }
        return res;
      };
    }
    document.addEventListener('shopify:section:load', watch);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
    else watch();
  })();

  // Mock 03 mini preview bar (phones): pinned under the header while the shopper picks options. Shown once the
  // variant picker's top reaches the header and while the main Add to cart is still below the screen; hidden
  // otherwise, and on 750 px and wider. While it shows, the bottom sticky Add to cart bar is hidden (html.ff-mini-on).
  (function () {
    var bar = null, raf = 0, last = '';
    function q(sel, root) { return (root || document).querySelector(sel); }
    function details() { return q('main .product-details') || q('.product-details'); }
    function header() { return q('header.header-section') || q('header'); }
    function frameKey(v) { v = String(v || '').toLowerCase(); return /black|espresso|walnut|natural/.test(v) ? (v.indexOf('walnut') >= 0 ? 'espresso' : v.replace(/ frame$/, '')) : 'unframed'; }
    function fill() {
      var d = details();
      if (!bar || !d) return;
      var picks = [].slice.call(d.querySelectorAll('variant-picker input[type="radio"]:checked')).map(function (i) { return i.value; });
      var frame = '';
      [].forEach.call(d.querySelectorAll('variant-picker input[type="radio"]:checked'), function (i) { if (/^frame$/i.test(i.getAttribute('data-option-name') || '')) frame = i.value; });
      var price = q('product-price [ref="priceContainer"] .price', d);
      var thumb = q('variant-picker input[type="radio"]:checked ~ .ff-style-thumb', d) || q('variant-picker label:has(input:checked) .ff-style-thumb', d);
      var key = picks.join('|') + '|' + (price ? price.textContent : '') + '|' + (thumb ? thumb.currentSrc || thumb.src : '');
      if (key === last) return;
      last = key;
      var img = q('[data-ff-mini-img]', bar);
      if (thumb && img && img.getAttribute('src') !== (thumb.currentSrc || thumb.src)) img.src = thumb.currentSrc || thumb.src;
      var pic = q('.ff-mini__pic', bar);
      if (pic) pic.setAttribute('data-ff-mini-frame', frameKey(frame));
      var t = q('[data-ff-mini-picks]', bar), p = q('[data-ff-mini-price]', bar);
      if (t) t.textContent = picks.join(' \u00b7 ');
      if (p) p.textContent = price ? price.textContent.trim() : '';
    }
    function check() {
      raf = 0;
      var d = details();
      if (!bar || !d) return;
      var picker = q('variant-picker', d), buy = q('.buy-buttons-block', d);
      var on = false;
      if (picker && buy && window.innerWidth < 750) {
        var h = header(), hb = h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
        bar.style.setProperty('--ff-mini-top', Math.round(hb) + 'px');
        on = picker.getBoundingClientRect().top < hb + 4 && buy.getBoundingClientRect().top > window.innerHeight - 4;
      }
      if (on) fill();
      bar.hidden = false;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.documentElement.classList.toggle('ff-mini-on', on);
    }
    function soon() { if (!raf) raf = setTimeout(check, 30); }
    function start() {
      var found = q('[data-ff-mini]');
      if (!found || found === bar) return;
      bar = found;
      if (bar.parentElement !== document.body) document.body.appendChild(bar); // fixed position, clear of any transformed parent
      q('[data-ff-mini-see]', bar).addEventListener('click', function () {
        var g = q('main .product-information__media') || q('main media-gallery');
        var show = g && g.querySelector('slideshow-component');
        if (show && typeof show.select === 'function' && show.current !== 0) show.select(0, undefined, { animate: false });
        if (g) {
          var h = header(), hb = h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
          window.scrollTo({ top: Math.max(0, g.getBoundingClientRect().top + window.scrollY - hb), behavior: 'smooth' });
        }
      });
      window.addEventListener('scroll', soon, { passive: true });
      window.addEventListener('resize', soon);
      new MutationObserver(function () { last = ''; soon(); }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
      soon();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();
  } catch(e) { console.error(e); }
})();

})();
